// SupportPage.jsx
import React from 'react';

const SupportPage = () => {
  return (
    <div style={{
      fontFamily: "'Segoe UI', sans-serif",
      backgroundColor: '#fefefe',
      color: '#333',
      margin: '40px auto',
      maxWidth: '800px',
      padding: '20px'
    }}>
      <h1 style={{ color: '#2c3e50', fontSize: '2rem', textAlign: 'center', marginBottom: '1rem' }}>
        🛠️ Support – Kya Banega Aaj
      </h1>
      <p style={{ textAlign: 'center' }}>
        We're here to help you get the best out of your <strong>Aaj Kya Banega</strong> experience! Whether you're having trouble logging in, facing issues with suggestions, or just want to give feedback — we're listening.
      </p>

      <section>
        <h2 style={{ color: '#2980b9', borderBottom: '2px solid #eee', paddingBottom: '5px' }}>🔹 Common Questions</h2>

        <details style={detailsStyle}>
          <summary style={summaryStyle}>1. How do I log in?</summary>
          <p>We use a secure OTP-based login system. Just enter your mobile number, and you’ll receive a one-time password to access the app.</p>
        </details>

        <details style={detailsStyle}>
          <summary style={summaryStyle}>2. Why am I not getting suggestions?</summary>
          <p>Make sure:</p>
          <ul style={ulStyle}>
            <li>You’ve logged at least one past meal</li>
            <li>You’ve selected your food preferences (veg/non-veg, etc.)</li>
            <li>You're connected to the internet</li>
          </ul>
          <p>Still not working? Reach out to us!</p>
        </details>

        <details style={detailsStyle}>
          <summary style={summaryStyle}>3. How do I share feedback or report a bug?</summary>
          <p>We’d love to hear from you. Scroll down to our contact options below.</p>
        </details>
      </section>

      <section>
        <h2 style={{ color: '#2980b9', borderBottom: '2px solid #eee', paddingBottom: '5px' }}>🔹 Technical Support</h2>
        <p>If you are facing any of the following:</p>
        <ul style={ulStyle}>
          <li>Login issues</li>
          <li>Meal suggestion errors</li>
          <li>App crashes</li>
          <li>Anything unexpected</li>
        </ul>
        <p>Please email us with:</p>
        <ul style={ulStyle}>
          <li>Your registered mobile number</li>
          <li>A brief description of the issue</li>
          <li>Screenshots, if possible</li>
        </ul>
      </section>

      <section style={contactBoxStyle}>
        <h2>📬 Contact Us</h2>
        <p><strong>Email:</strong> <a href="mailto:contact@aajkyabanega.com" style={linkStyle}>contact@aajkyabanega.com</a></p>
        <p><strong>Website:</strong> <a href="https://www.aajkyabanega.com/support" target="_blank" rel="noreferrer" style={linkStyle}>www.aajkyabanega.com/support</a></p>
        <p><strong>Support Hours:</strong> 10 AM – 11 PM (Mon–Friday, IST)</p>
      </section>

      <div style={{ marginTop: '30px', fontStyle: 'italic', textAlign: 'center' }}>
        <p>🙏 Thank You!<br />
          We’re building Aaj Kya Banega to make your daily cooking decision easier.<br />
          Your feedback and support mean everything to us!
        </p>
      </div>
    </div>
  );
};

// Inline styles
const detailsStyle = {
  backgroundColor: '#f9f9f9',
  border: '1px solid #ddd',
  padding: '12px 16px',
  marginBottom: '10px',
  borderRadius: '6px',
  cursor: 'pointer'
};

const summaryStyle = {
  fontWeight: 'bold',
  fontSize: '1.05rem'
};

const ulStyle = {
  marginTop: '5px',
  paddingLeft: '20px',
  fontSize: '1rem'
};

const contactBoxStyle = {
  background: '#ecf0f1',
  padding: '15px',
  marginTop: '20px',
  borderLeft: '5px solid #3498db'
};

const linkStyle = {
  color: '#2980b9',
  textDecoration: 'none'
};

export default SupportPage;
